import Asset from "../../../requests/apa/Asset"
import Utils from "../../../utils/Utils"

export const tranformGroupsResponse = (groups) => {
    if (!groups || !groups.length) return []
    
    return groups.map(group => ({
        id: group.groupCode,
        label: group.groupName || '',
        teams: transformTeams(group.teams)
    }))
}

export const transformRankingResponse = (ranking) => {
    if (!ranking || !ranking.length) return []
    
}

export const transformTeams = (teams) => {
    return teams.map(team => ({
            position: Utils.cutPlayerString(team.rank, 3),
            team:{
                id: team.team.id,
                name: Utils.cutPlayerString(team.team.name, 25),
                flagUrl: team && team.team && team.team.flagUrl ? team.team.flagUrl : Asset.get('eventodeportivo_placeholder_imagen_bandera_1')
            },   
            pts: Utils.cutPlayerString(team.stats && team.stats.points || 0, 3), 
            ptd: Utils.cutPlayerString(team.stats && team.stats.played || 0, 3),
            g: Utils.cutPlayerString(team.stats && team.stats.won || 0, 3),
            e: Utils.cutPlayerString(team.stats && team.stats.drawn || 0, 3),
            p: Utils.cutPlayerString(team.stats && team.stats.lost || 0, 3),
            gf: Utils.cutPlayerString(team.stats && team.stats.goalsFor || 0, 3),
            gc: Utils.cutPlayerString(team.stats && team.stats.goalsAgainst || 0, 3),
            gd: Utils.cutPlayerString(team.stats && team.stats.goalDifference || 0, 3),
            qualifies: team && team.qualification && team.qualification.status || ''
        })) 
}


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/TablaDePosiciones/utils.js